class ChatValidation {
  static Room(State = {}) {
    const { Name, Users } = State;
    const errors = [];
    if (!Name) errors.push("NAME_REQUIRED");
    if (!Users || Users.length < 1) errors.push("USERS_LENGTH_REQUIRED");
    return errors;
  }
}

export default ChatValidation;
